module.exports = __webpack_public_path__ + "img/p3_3.6c1881be.png";